import type { RouteObject } from 'react-router';
import LandingScreen from './screens/landing/landing.screen';
import HomeScreen from './screens/home/home.screen';
import LoginScreen from './screens/login/login.screen';
import ProfileScreen from './screens/profile/profile.screen';
import SystemInformationScreen from './screens/systemInformation/systemInformation.screen';
import SettingsScreen from './screens/settings/settings.screen';
import PatientOverviewScreen from './screens/patientOverview/patientOverview.screen';
import AudioSettingsScreen from './screens/audioSettings/audioSettings.screen';
import RecordingScreen from './screens/recording/recording.screen';
import ResultScreen from './screens/result/result.screen';
import ProgressIndicationPopupScreen from './screens/progressIndicationPopup/progressIndicationPopup.screen';
import App, { ErrorBoundary } from './root';
import { RecordingSessionProvider } from './providers/RecordingSessionProvider';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <App />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        index: true,
        element: <LandingScreen />,
      },
      {
        path: 'login',
        element: <LoginScreen />,
      },
      {
        path: 'home',
        element: <HomeScreen />,
      },
      {
        path: 'profile',
        element: <ProfileScreen />,
      },
      {
        path: 'systemInformation',
        element: <SystemInformationScreen />,
      },
      {
        path: 'settings',
        element: <SettingsScreen />,
      },
      {
        path: 'audio-settings',
        element: <AudioSettingsScreen />,
      },
      {
        element: <RecordingSessionProvider />,
        children: [
          {
            path: 'patient-overview/:medatixxPatientId',
            element: <PatientOverviewScreen />,
          },
          {
            path: 'recording/:medatixxPatientId?',
            element: <RecordingScreen />,
          },
          {
            path: 'result/:id',
            element: <ResultScreen />,
          },
        ],
      },
      {
        path: 'progress-indication-popup',
        element: <ProgressIndicationPopupScreen />,
      },
    ],
  },
];

export default routes;
